import React from "react";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import { useNavigate } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
export const CustomerLeftMenu: React.FunctionComponent = () => {
  let navigate = useNavigate();

  return (
    <>
      <ListItem disablePadding>
        <ListItemButton
          onClick={() => {
            navigate("/");
          }}
        >
          <ListItemIcon>
            <DashboardIcon sx={{ color: "#ffff" }} />
          </ListItemIcon>
          <ListItemText primary={"Dashboard"} />
        </ListItemButton>
      </ListItem>
      <ListItem disablePadding>
        <ListItemButton
          onClick={() => {
            navigate("/Customer/Orders");
          }}
        >
          <ListItemIcon>
            <LibraryBooksIcon sx={{ color: "#ffff" }} />
          </ListItemIcon>
          <ListItemText primary={"My Orders"} />
        </ListItemButton>
      </ListItem>

      <ListItem disablePadding>
        <ListItemButton
          onClick={() => {
            //navigate("/ManageProducts");
          }}
        >
          <ListItemIcon>
            <ManageSearchIcon sx={{ color: "#ffff" }} />
          </ListItemIcon>
          <ListItemText primary={"Invoices"} />
        </ListItemButton>
      </ListItem>
    </>
  );
};
